import { useRef, useState } from 'react'
import Barcode from 'react-barcode'

import ControlsBar from 'app/common/ui-next/controls-bar'
import PlainButton from 'app/common/ui-next/plain-button'
import PlainInput from 'app/common/ui-next/plain-input'
import PlainLabel from 'app/common/ui-next/plain-label'
import PlainHelperText from 'app/common/ui-next/plain-helper-text'
import PlainRadioButton from 'app/common/ui-next/plain-radio-button'
import PlainFieldset from 'app/common/ui-next/plain-fieldset'
import PlainButtonAsLink from 'app/common/ui-next/plain-button-as-link'
import PlainIcon, { iconType, iconColor } from 'app/common/ui-next/plain-icon'

import PlainModal, {
  PlainModalContent,
  PlainModalFooter,
  PlainModalHeader,
} from 'app/common/ui-next/plain-modal'

import styles from './BarCodeModal.module.scss'

export const BarCodeModal = ({ title, onClose }: { title: string; onClose: () => void }) => {
  const inputFocused = useRef(false)
  const [codes, setCodes] = useState(new Set<string>())
  const firstCode = Array.from(codes)[0] || undefined
  const [selected, setSelected] = useState('')
  const [input, setInput] = useState('')
  const [error, setError] = useState('')
  const primaryCode = selected || firstCode

  const handleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInput(e.target.value)
    setError('')
  }

  const handleAddCode = () => {
    if (codes.has(input)) {
      setError('Такой штрих-код уже добавлен')
      return
    }
    setCodes((prev) => new Set([...prev, input]))
    setInput('')
  }

  const handleRemoveCode = (code: string) => {
    setCodes((prev) => new Set([...prev].filter((c) => c !== code)))
  }

  const handleInputKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      handleAddCode()
    }
  }

  const handleSubmit = () => {
    if (inputFocused.current) {
      handleAddCode()
      return
    }
    console.log('submit')
  }

  return (
    <PlainModal show formId="barcode" onSubmit={handleSubmit} className={styles.root}>
      <PlainModalHeader onCrossClick={onClose}>{`Штрих-код «${title}»`}</PlainModalHeader>

      <PlainModalContent className={styles.content}>
        {codes.size > 0 && (
          <div className={styles.codesLayout}>
            <div>
              {codes.size === 1 && !!firstCode && (
                <div className={styles.fieldsetItem}>
                  <div className={styles.firstCodeSolo}>{firstCode}</div>
                  <PlainButtonAsLink onClick={() => handleRemoveCode(firstCode)}>
                    <PlainIcon
                      width="12px"
                      type={iconType.LIGHT_CROSS}
                      color={iconColor.COLOR_DARKGRAY}
                    />
                  </PlainButtonAsLink>
                </div>
              )}

              {codes.size > 1 && (
                <PlainFieldset
                  legend="Установить основной"
                  className={styles.fieldset}
                  skipUpperSpace
                >
                  {Array.from(codes).map((code) => (
                    <div key={code} className={styles.fieldsetItem}>
                      <PlainRadioButton
                        checked={primaryCode === code}
                        name="code"
                        value={code}
                        label={code}
                        onChange={() => setSelected(code)}
                      />
                      <PlainButtonAsLink onClick={() => handleRemoveCode(code)}>
                        <PlainIcon
                          width="12px"
                          type={iconType.LIGHT_CROSS}
                          color={iconColor.COLOR_DARKGRAY}
                        />
                      </PlainButtonAsLink>
                    </div>
                  ))}
                </PlainFieldset>
              )}
            </div>

            {primaryCode && (
              <div>
                <Barcode
                  value={primaryCode}
                  width={2}
                  height={90}
                  // displayValue={false}
                  background="transparent"
                  margin={0}
                />
              </div>
            )}
          </div>
        )}
        <div>
          <PlainLabel htmlFor="add" skipUpperSpace displayAsBlock>
            {'Введите штрих-код'}
          </PlainLabel>
          <div className={styles.addingLayout}>
            <PlainInput
              className={styles.addingInput}
              value={input}
              onChange={handleInput}
              onFocus={() => (inputFocused.current = true)}
              onBlur={() => (inputFocused.current = false)}
              onKeyDown={handleInputKeyDown}
              id="add"
              placeholder="Штрих-код"
              error={!!error}
            />
            <PlainButton onClick={handleAddCode} disabled={!input}>
              {'Добавить'}
            </PlainButton>
          </div>
          {error && <PlainHelperText error>{error}</PlainHelperText>}
        </div>
      </PlainModalContent>

      <PlainModalFooter>
        <ControlsBar right>
          <PlainButton onClick={onClose} outline>
            {'Закрыть'}
          </PlainButton>
          <PlainButton
            type="submit"
            // disabled={!primaryCode}
            disabled
          >
            {'Подтвердить'}
          </PlainButton>
        </ControlsBar>
      </PlainModalFooter>
    </PlainModal>
  )
}
